// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fxxv","comment":"styles_comment__27X_-"};